// NPDT 인트로 페이지 정적 데이터 — 실제 값은 이 파일만 수정하면 됩니다.
export const site = {
  name: 'NPDT',
  fullName: 'News-based Plant Disease Tracker',
  github: 'https://github.com/hope9901/NPDT',
  email: 'hope9901@naver.com',
  paper: {
    title: 'Digital Surveillance and Outbreak Analysis of Fire Blight Using News-Based Text Mining',
    venue: 'Smart Agricultural Technology · 2026',
    url: 'https://doi.org/10.1016/j.atech.2026.101928',
  },
  lab: '국립순천대학교 농업생물정보학 실험실',
  diseases: [
    { ko: '과수화상병', host: '사과 · 배', tone: '#E53935' },
    { ko: '도열병', host: '벼', tone: '#F9A825' },
    { ko: '소나무재선충병', host: '소나무', tone: '#2E7D32' },
  ],
  dashboardUrl: '/fblight',
} as const
